export default __webpack_public_path__ + "static/media/outside-Right_KFS_WARM_WAND_MW_EPS.0eaf8ad9.jpg";